import React, { useEffect, useState } from 'react';

// Packages
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const PayloadMap = (props) => {
	const { locationLat, locationLng, userLat, userLng } = props;
	
	const { t } = useTranslation();

	const [distMeters, setDistMeters] = useState(0);

	// Function to calculate the distance between two geographical points using the Haversine formula
	const haversineDistance = (locationLat, locationLng, userLat, userLng) => {
		const R = 6371e3; // 6371 km => 6371e3 meters
	
		const toRad = (val) => (val * Math.PI) / 180;
	
		const φ1 = toRad(locationLat);
		const φ2 = toRad(userLat);
		const Δφ = toRad(userLat - locationLat);
		const Δλ = toRad(userLng - locationLng);
	
		const a =
			Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
			Math.cos(φ1) * Math.cos(φ2) *
			Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
	
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	
		const distance = R * c; // In meters
		return distance;
	}
	
	// Function to round to integer
	const getDistanceBetweenTwoPoints = (locationLat, locationLng, userLat, userLng) => {
		const distance = haversineDistance(locationLat, locationLng, userLat, userLng);
		return Math.round(distance);
	}
	
	useEffect(() => {
		const distMeters = getDistanceBetweenTwoPoints(locationLat, locationLng, userLat, userLng);
		setDistMeters(distMeters);
	}, [locationLat, locationLng, userLat, userLng]);

	// Sets the URL for the Google Maps static map
	const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?
		size=1000x200
		&scale=2
		${distMeters < 50 ? '&zoom=18' : ''}
		&markers=color:red%7Clabel:A%7C${locationLat},${locationLng}
		&markers=color:blue%7Clabel:B%7C${userLat},${userLng}
		&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
		&style=feature:transit|visibility:off
		&path=color:0x0000ff|weight:5|${locationLat},${locationLng}|${userLat},${userLng}`;
	
	return (
		<div className='map' style={{ position: 'relative', display: 'inline-block' }}>
			<img
				className='map'
				src={mapUrl}
				alt='Location Map'
				onError={(e) => {
					console.error('Error loading static map:', e);
				}}
			/>
			<p hidden>{distMeters.toLocaleString(localStorage.getItem('i18nextLng'))} meters</p>
		</div>
	);
}

PayloadMap.propTypes = {
	locationLat: PropTypes.number.isRequired,
	locationLng: PropTypes.number.isRequired,
	userLat: PropTypes.number.isRequired,
	userLng: PropTypes.number.isRequired
};

export default PayloadMap;
